<template>
  <v-layout>
    <v-dialog v-model="dialog" lazy persistent max-width="700px">
      <v-btn slot="activator" class="ma-0" color="primary">
        <v-icon small class="pr-1">add</v-icon>
        Add user
      </v-btn>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close"><v-icon>close</v-icon></v-btn>
          <v-toolbar-title>Close without saving</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-title class="mb-0 pb-0">
          <h5>
            <v-icon medium color="yellow">add</v-icon>
            Add user
          </h5>
          <blockquote>
            Add user or go back to the previous page by clicking the "x" in the
            top left corner
          </blockquote>
        </v-card-title>
        <v-card-text>
          <customer-detail-form-add
            ref="userFormAdd"
            :loading="loading"
            @save="save"
          ></customer-detail-form-add>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CustomerDetailFormAdd from "@/components/CustomerDetailFormAdd.vue";

export default {
  components: {
    CustomerDetailFormAdd
  },
  data() {
    return {
      dialog: false,
      loading: false
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save(data) {
      this.loading = true;
      this.$store
        .dispatch("admin/addCustomerDetailItem", {
          customerId: this.$route.params.customerId,
          data
        })
        .then(() => {
          this.dialog = false;
          this.loading = false;
          this.$refs.userFormAdd.reset();
        });
    }
  }
};
</script>
